<section class="cookie-message"
         *ngIf="!isApplied">
  <h3 class="visually-hidden">Предупреждение об использовании файлов "cookie"</h3>
  <div class="cookie-message__inner-wrap">
    <p class="cookie-message__text">Продолжая использовать наш сайт, вы даёте&nbsp;
      <a class="cookie-message__link"
         href="https://travelsys.pro/cookie-agreement"
         target="_blank">согласие на использование файлов "cookie"</a>
      <span class="cookie-message__additional-message">.&nbsp;Если вы не хотите, чтобы ваши данные обрабатывались, измените настройки
                                    браузера.</span>
    </p>
  </div>
  <button class="cookie-message__btn button"
          (click)="acceptCookie()">
    <span class="button__accept">Принимаю</span>
    <span class="button__ok">Ок</span>
  </button>
</section>
